import { defineMessages } from 'react-intl.macro';

export default defineMessages({
  category: {
    id: 'GeneralMeetingsMd.category',
    defaultMessage: 'Kategoria:'
  }
});



// WEBPACK FOOTER //
// ./src/views/GeneralMeetings/GeneralMeetingsMd.intl.js